import React from 'react';
import PropTypes from 'prop-types';

import {Avatar, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText} from '@material-ui/core';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  secondaryAction: {
    paddingRight: 92
  },
  toggleButton:  {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    marginLeft: '0 !important',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
      backgroundColor: theme.palette.primary.dark,
    },
    '&$selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  selected: {},
}));

function SiteList({sites, modes, selectedSite, selectedMode, onChange}) {
  const classes = useStyles();

  const handleChange = (e, value) => {
    const [mode, ...site] = value ? value.split('-') : [];
    onChange({
      site: site.length ? site.join('-') : undefined,
      mode
    });
  };

  return <List disablePadding dense>
    {sites.map(site =>
      <ListItem disableGutters classes={classes} key={site.id}>
        <ListItemIcon style={{minWidth:0, padding: '0 12px 0 4px'}}>
          <Avatar style={{backgroundColor: '#FFFC', border: '1px solid #0003'}}>{site.icon}</Avatar>
        </ListItemIcon>
        <ListItemText secondary={site.label}/>
        <ListItemSecondaryAction style={{minWidth:0, right: 8}}>
          <ToggleButtonGroup
            size='small'
            value={`${selectedMode}-${selectedSite}`}
            exclusive
            onChange={handleChange}
            style={{boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'}}>
            {modes.map(mode =>
              <ToggleButton
                key={`${mode.id}-${site.id}`}
                value={`${mode.id}-${site.id}`}
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selected,
                }}>
                {mode.icon}
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        </ListItemSecondaryAction>
      </ListItem>
    )}
  </List>;
}

SiteList.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.element,
  })).isRequired,
  modes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.element,
  })).isRequired,
  selectedSite: PropTypes.string,
  selectedMode: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default SiteList;
